import {useEffect, useState} from "react";
import {useTranslation, withTranslation} from "react-i18next";
import Headerbutton from "../../component/headerButton";
import localOrSessionStore from "../../../../_helpers/localOrSessionStore";
import variables from "../../../../_constants/variables";
import comunidades from "../../../../_constants/comunidades";
import luxs from "assets/img/luxluz.png";
import chronos from "assets/img/chronos/chronos-senala.png";
import {Button, Modal} from "antd";
import {
    ArrowRightOutlined,
    EditOutlined,
    LeftOutlined,
    ReloadOutlined
} from "@ant-design/icons";
import {history} from "../../../../_helpers";
import {xcService} from "../../../../_services/xcService";
import report from '../../../../assets/img/report.png';
import _ from "lodash";
import endpoint from "shared/endpoints";

function FinishTek(props) {

    const storage = localOrSessionStore({ key: variables.REMEMBER });
    const user = JSON.parse(storage.getItem(variables.USER));
    const { t} = useTranslation();

    const [isEnd, setEnd] = useState(false);
    const [step,setStep] = useState(0);
    const [portalButton, setPortalButton] = useState(false);
    const [portalImage, setPortalImage] = useState();
    const [images,setImages] = useState();
    const [userQuest,setUserQuest] = useState();
    const [answers, setAnswers] = useState();

    useEffect(()=>{
        if(!userQuest) return
        setImages({
            2: t(`tek.${userQuest}.comicend1`),
            3: t(`tek.${userQuest}.comicend2`)
        });
        setPortalImage('../assets/img/tek/open-portal.gif');
    },[t,userQuest])

    const setQuest = (course) => {
        const quests = {
            '3º ESO': 'itin1',
            '4º ESO': 'itin2',
            '1º Bachillerato': 'itin3',
            '2º Bachillerato': 'itin4',
            'FP Grado Básico': 'itin2',
            'FP Grado Medio': 'itin4',
        }
        setUserQuest(quests[course])
    }

    const codes = {
        '3º ESO': 'TEK3ESO',
        '4º ESO': 'TEK4ESO',
        '1º Bachillerato': 'TEK1BAC',
        '2º Bachillerato': 'TEK2BAC',
        'FP Grado Básico': 'TEKFPB',
        'FP Grado Medio': 'TEKFPM',
    }

    useEffect(()=>{
        xcService.getToken('/v1/student/course')
            .then(({data})=> {
                setQuest(data.data.name)
                return data.data.name
            }).then(course=>
                xcService.getToken( endpoint.studentAnswer.getAll(codes[course], { query: { withResponses: true } }))
            ).then(({data})=> {
                setAnswers(data.data);
                let lastResponse = data.data[data.data.length - 1];

                let mInfo = 1;
                if (lastResponse && lastResponse.response && lastResponse.response.question === "No"){
                    mInfo = 0;
                }
                xcService.putToken('/v1/info', {info: mInfo}).then(data => {})
            }

        )

    },[])

    useEffect(()=>{
        isEnd && setPortalButton(true);
        isEnd&&setTimeout(()=> {
            setPortalImage('../assets/img/tek/loop-portal.gif');
        }, 3000);
    },[isEnd]);

    /* ToDo : Revisar funcion para que se guarde la informacion del formulario tek */
    const  saveAndContinue = () => {
        //localStorage.removeItem(variables.LASTNOGAM3);
        history.push("/admin/assessment")
    }

    const showResponse = (item) => {
        if (item.points === 999){
            if (item.assessment.questionType=== "CFGM"){
                return t("tek.questionnaire.checkCFGM")
            }
            if (item.assessment.questionType=== "CFGS"){
                return t("tek.questionnaire.checkCFGS")
            }
            if (item.assessment.questionType=== "SUBJECT") {
                return t("tek.questionnaire.checkbtx")

            }
            return t("tek.questionnaire.noseguro")

        }else {
            if (item.assessment.questionType=== "COMAUT") {
                let mCom = _.filter(
                    comunidades, function (o) {
                        return o.code === item.points;
                    }
                );
                if (mCom && mCom[0]) return mCom[0].name;

                return "";

            }else if (item.assessment.questionType=== "MULTIPLE3" || item.assessment.questionType=== "MULTIPLE2" || item.assessment.questionType=== "MULTIPLE4") {
                let mText = item.subanswers.map(sub => sub.response.question).join(', ')

                return mText
            }else {
                if (item.response) {
                    return item.response?.question
                } else {
                    if (item.degree) {
                        return item.degree.title
                    }
                    if (item.subject) {
                        let mText = item.subject.modality + " - " + item.subject.subject;
                        let order = _.orderBy(item?.subanswers, ["subject.order"], ['asc']);
                        if (order && order[0] && order[1] && order[2]) {
                            mText += "<br>" + t("tek.mimodalidad") + ": " + order[0]?.subject?.subject + " " + t("and") + " " + order[1]?.subject?.subject
                            mText += "<br>" + t("tek.mioptativa") + ": " + order[2]?.subject?.subject
                        }
                        return mText
                    }
                }
            }
        }

    }

    const [showModal, setShowModal] = useState(false);
    const [showModalSelection, setShowModalSelection] = useState(true);

    const [unsureValue, setUnsureValue] = useState(false);
    const [points, setPoints] = useState(0)
    const [answer, setAnswer] = useState(null);


    const saveResponse = () => {
        setShowModal(false)
    }


    const Continue = () => {
        setShowModal(false)

    }

    return (
        <>

            {showModal &&
                <Modal className={"modalName modal-question"} title={t("ceiba.modificar")}
                       centered
                       visible={showModal} onOk={Continue}
                       onCancel={Continue}>
                    <div className={"container-question"}>
                        <div className={"container-question__auto-margin"}>
                            <div className={"question__header"}>
                                <p dangerouslySetInnerHTML={{__html: "<strong>" + "" + "</strong>"}} />

                            </div>
                            <div className={"question__content"}>

                                <div className={"question__content-bottom"}>
                                    <Button onClick={() => saveResponse()}

                                            type={"primary"}
                                            className="primaryButton buttonSizeO"
                                    >
                                        {showModalSelection?t("saveclose"):t("close")}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            }

            {!isEnd && step === 0 && <>
                <div className={"backGroundCeiba"}>
                    <div className={"wrapper-question boxed"}>
                        <div className={"insideCeiba boxed"}>
                            <Headerbutton saveAndContinue={saveAndContinue} title={t("tek.header")}/>
                        </div>
                        <div className={"container-question container-question__end no-gamificado"}>
                    <div className={"container-question__auto-margin"}>
                        <div className={"question__header"}>
                            <img className={"question__header-icon"} src={report}/>
                            <h2>{t("tek.endtitle")}</h2>
                        </div>
                        <div className={"question__content"}>
                            <div className={"question__content-list"}>
                                {answers&&answers.map (item => (
                                    <div className={"list-item"} key={item.id}>
                                        <div className={"list-item-l"}>
                                            <p dangerouslySetInnerHTML={{__html: item.assessment?.question}} />
                                        </div>
                                        <div className={"list-item-r"}>
                                            <p dangerouslySetInnerHTML={{__html: showResponse(item)}}></p>
                                        </div>

                                        <div
                                            className={"modifica"}
                                            onClick={() => history.push('/admin/start-tek?restart=true&inStep=' + (+item.assessment.order-1))}
                                        >
                                            {t("ceiba.modificar")}&nbsp;<EditOutlined/>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className={"question__content-bottom"}>
                                <div className="left">
                                    <Button
                                        disabled={false}
                                        icon={<ReloadOutlined />}
                                        onClick={() => {
                                            localStorage.removeItem(variables.LASTTEK);
                                            history.push('/admin/tek-instructions?restart=true');
                                        }}
                                        type={"secondary"}
                                        className="primaryButton"
                                    >
                                        {t("reset")}
                                    </Button>
                                </div>
                                <div className="right">
                                    <Button
                                        icon={<ArrowRightOutlined/>}
                                        type={"primary"}
                                        className="primaryButton"
                                        onClick={()=>setStep(step+1)}
                                    >
                                        {t("next")}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                    </div>
                </div>
            </>
            }{!isEnd && step === 1 && <>
                <div className={"backGroundFinishTek wrapper history tek-ok"}>
                    <div className={"insideTek boxed"}>
                        <Headerbutton saveAndContinue={saveAndContinue} />
                    </div>
                    <div className={"container-history boxed"}>
                        <img className={"character character--lux"} src={luxs} alt={""}/>
                        <div className={"container-dialogue"}>
                            <div className={"dialogue-content-text"}>
                                <p className={"dialogue-text"}
                                   dangerouslySetInnerHTML={{__html: t(`tek.${userQuest}.finish1`).replace("#name#", user.name)}}></p>
                            </div>
                            <div className={"dialogue-buttons"}>
                                <div className="left margin-right-auto">
                                    <Button
                                      icon={<LeftOutlined/>}
                                      type={"link"}
                                      onClick={() => setStep(step-1)}
                                    >
                                        {t("atras")}
                                    </Button>
                                </div>
                                <div className="right">
                                    <Button onClick={() => history.push("/admin/assessment")}
                                            className="primaryButton"
                                    >
                                        {t("tek.irahome")}
                                    </Button>
                                    <Button icon={<ArrowRightOutlined/>}
                                            onClick={() => setStep(step + 1)}
                                            type={"primary"}
                                            className="primaryButton"
                                    >
                                        {t("tek.verfinal")}
                                    </Button>
                                </div>
                            </div>
                            <p className={"dialogue-name"}>
                                <strong>LUX</strong>
                            </p>
                        </div>
                    </div>
                </div>
            </>
            }
            {!isEnd && step===2 && <>
                <div className={"backGroundFinishTek wrapper history tek-portal"}>
                    <div className={"insideTek boxed"}>
                        <Headerbutton saveAndContinue={saveAndContinue} />
                    </div>
                    <div className={"container-history boxed"}>
                        <img className={"character character--chronos character--center"} src={chronos} alt={""}/>
                        <div className={"container-dialogue"}>
                            <div className={"dialogue-content-text"}>
                                <p className={"dialogue-text"}
                                   dangerouslySetInnerHTML={{__html: t(`tek.${userQuest}.finish2`)}}></p>
                            </div>
                            <div className={"dialogue-buttons"}>
                                <div className="left margin-right-auto">
                                    <Button
                                      icon={<LeftOutlined/>}
                                      type={"link"}
                                      onClick={() => setStep(0)}
                                    >
                                        {t("atras")}
                                    </Button>
                                </div>
                                <div className="right">
                                    <Button icon={<ArrowRightOutlined />}
                                            onClick={() => setEnd(true)}
                                            type={"primary"}
                                            className="primaryButton"
                                    >
                                        {t("tek.activeportal")}
                                    </Button>
                                </div>
                            </div>
                            <p className={"dialogue-name"}>
                                <strong>CHRONOS</strong>
                            </p>
                        </div>
                    </div>
                </div>

                </>
            }
            {isEnd &&

                  <div className={"containerStartTekTwo wrapper history tek-page-comic"}
                       style={{backgroundImage: `url(${step===2?portalImage:images[step]})`}}
                  >
                      <div className={"insideTek boxed"}>
                          <Headerbutton saveAndContinue={saveAndContinue}  />
                      </div>
                      <div className={"container-history boxed"}>
                          <div className={"container-dialogue container-dialogue--no-text"}>
                              <div className={"dialogue-buttons"}>
                                  <div className="left margin-right-auto">
                                      <Button
                                          icon={<LeftOutlined />}
                                          type={"link"}
                                          onClick={() => step===3 ? setStep(step-1):setEnd(false)}
                                      >
                                          {t("atras")}
                                      </Button>
                                  </div>
                                  <div className="right">
                                      {portalButton && <Button icon={<ArrowRightOutlined/>}
                                               onClick={() => step===3?history.push("/admin/assessment"):setStep(step+1)}
                                               type={"primary"}
                                               className="primaryButton"
                                      >
                                          {step===3?t("tek.irahome"):t("assessment.next")}
                                      </Button>}
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
            }

        </>
    )
}
export default withTranslation()(FinishTek);
